import React from 'react';
import StarIcon from '@mui/icons-material/Star';
import ProgressBar from './ProgressBar';

const RatingProgress = ({ starValue, starReviewValue, reviewCount }) => (
  <div className="flex w-full items-center space-x-3 text-[13px]">
    <div className="flex w-[34px] shrink-0 items-center text-slate-600">
      {starValue}
      <StarIcon style={{ fontSize: '14px', marginLeft: '2px', color: '#f59e0b' }} />
    </div>
    <div className="min-w-0 flex-1">
      <ProgressBar
        width={(starReviewValue / reviewCount) * 100}
        background="#f59e0b"
      />
    </div>
    <div className="w-[44px] shrink-0 text-right text-xs tabular-nums text-slate-400">
      {`(${starReviewValue})`}
    </div>
  </div>
);

export default RatingProgress;
